/**
 * Dev Mail - Mail Subcommand Group
 */
import { Command } from 'commander';
import chalk from 'chalk';
import { createMailCreateCommand } from './create.js';
import { createMailListCommand } from './list.js';
import { createMailRandomCommand } from './random.js';
import { createMailInboxCommand } from './inbox.js';
import { createMailReadCommand } from './read.js';
import { createMailWatchCommand } from './watch.js';
import { createMailPurgeCommand } from './purge.js';
import { createMailDeleteCommand } from './delete.js';

function showMailHelp(): void {
    console.log(chalk.bold.cyan('📬 j dev mail') + chalk.dim(' - Temp email cho môi trường dev'));
    console.log();
    console.log(chalk.bold('Quản lý accounts:'));
    console.log(`  ${chalk.cyan('create')}    Tạo temp email account mới`);
    console.log(`  ${chalk.cyan('list')}      Liệt kê tất cả accounts`);
    console.log(`  ${chalk.cyan('random')}    Lấy ngẫu nhiên 1 địa chỉ`);
    console.log(`  ${chalk.cyan('delete')}    Xóa 1 account`);
    console.log();
    console.log(chalk.bold('Email:'));
    console.log(`  ${chalk.cyan('inbox')}     Xem inbox (emails gần nhất)`);
    console.log(`  ${chalk.cyan('read')}      Đọc nội dung email`);
    console.log(`  ${chalk.cyan('watch')}     Lắng nghe email mới (polling)`);
    console.log(`  ${chalk.cyan('purge')}     Xóa toàn bộ emails của 1 account`);
    console.log();
    console.log(chalk.bold('Ví dụ:'));
    console.log(chalk.dim('  $ j dev mail create'));
    console.log(chalk.dim('  $ j dev mail create --name test'));
    console.log(chalk.dim('  $ j dev mail list'));
    console.log(chalk.dim('  $ j dev mail watch user@dollicons.com'));
    console.log();
    console.log(chalk.dim('  Tất cả lệnh đều hỗ trợ -j / --json'));
    console.log(chalk.dim('  Chạy "j dev mail <lệnh> --help" để xem chi tiết'));
}

export function createMailCommand(): Command {
    const cmd = new Command('mail')
        .description('Temp email management cho dev environment')
        .action(() => {
            showMailHelp();
        });

    cmd.addCommand(createMailCreateCommand());
    cmd.addCommand(createMailListCommand());
    cmd.addCommand(createMailRandomCommand());
    cmd.addCommand(createMailInboxCommand());
    cmd.addCommand(createMailReadCommand());
    cmd.addCommand(createMailWatchCommand());
    cmd.addCommand(createMailPurgeCommand());
    cmd.addCommand(createMailDeleteCommand());

    return cmd;
}
